import { Button } from "@9amhealth/shared";
import styled from "@emotion/styled";
import Translate from "components/Translate/Translate";
import type { FC } from "react";
import React from "react";
import { BlueCheckmarkBadge } from "src/constants/icons";
import Track from "../../../Track/Track";
import LabStatusOverview from "../../../LabStatusOverview/LabStatusOverview";
import { iconUrlClipboardCheck } from "src/constants/iconUrls";

const Container = styled.div`
  max-width: 480px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--space-md);
  text-align: center;

  h1 {
    text-wrap: pretty;
  }
`;

const LeanMoreLink = styled.div`
  margin: var(--space-xs) 0 var(--space-md);
  font-size: 1.1em;
  color: var(--color-highlight-blue);
  text-decoration: none;
  cursor: pointer;
`;

interface StatusStepProps {
  state: {
    labsVerified: boolean;
    statusTitle: string;
    showLabStatusOverview: boolean;
    showPushNotificationButton?: boolean;
    underReview: boolean;
    canSkipInitialLabsButton: boolean;
  };
  pushNotificationsEnabled: boolean;
  onClose: () => void;
  onShowLearnMore: () => void;
  onTogglePushNotifications: (enabled: boolean) => void;
}

const StatusStep: FC<StatusStepProps> = ({
  state,
  pushNotificationsEnabled,
  onClose,
  onShowLearnMore,
  onTogglePushNotifications
}) => {
  return (
    <Container>
      <Track
        event="Initial Labs Dialog Status Shown"
        data={{
          ...state
        }}
      />

      <div style={{ position: "relative", display: "inline-block" }}>
        <img src={iconUrlClipboardCheck} alt="Clipboard with a checkmark" />
        <div style={{ position: "absolute", top: "12px", right: "75px" }}>
          {state.labsVerified && <BlueCheckmarkBadge />}
        </div>
      </div>

      <h1 className="as-subhead2">
        <Translate
          msg="task.yourInitialLab.title"
          variables={{ context: state.statusTitle }}
        />
      </h1>
      <LeanMoreLink>
        <Button onPress={onShowLearnMore} theme="transparent">
          <Translate msg="button.learnMore" />
        </Button>
      </LeanMoreLink>

      {state.showLabStatusOverview && <LabStatusOverview />}

      {state.showPushNotificationButton &&
        !pushNotificationsEnabled &&
        state.underReview && (
          <Button
            style={{ marginTop: "0.5rem" }}
            theme="sunrise"
            onPress={() => onTogglePushNotifications(true)}
          >
            <Translate msg="notification.turnOn" />
          </Button>
        )}

      {!state.underReview && (
        <>
          <nine-spacer s="lg" />
          <Button
            style={{ marginTop: "0.5rem" }}
            theme="sunrise"
            onPress={onClose}
          >
            <Translate msg="continue" />
          </Button>
        </>
      )}

      {state.canSkipInitialLabsButton && (
        <Button
          style={{ marginTop: "0.5rem" }}
          theme="transparent"
          onPress={onShowLearnMore}
        >
          <Translate
            msg="skipInitialLabs"
            variables={{ context: state.statusTitle }}
          />
        </Button>
      )}
    </Container>
  );
};

export default StatusStep;
